import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppState } from '../../app.service';
import { AccountService } from '../../../services/account.service';
import { ShopifyBuyService } from '../../../services/shopify.service';
import { ToastHelperService } from '../../../services/toast-helper.service';
import { Router } from '@angular/router';
import { ACCOUNT_URLS } from '../../app.routes.names';
import { CommonModule } from '@angular/common';

export interface ModalAutoPayData {
  title?: string;
  subtitle?:string;
  buttonText?: string;
  buttonText2?: string;
  customClass?: string;
  customHTML?: string;
}

@Component({
  selector: 'app-auto-pay-modal',
  imports: [TranslateModule, CommonModule],
  templateUrl: './auto-pay-modal.component.html',
  styleUrl: './auto-pay-modal.component.scss'
})

export class AutoPayModalComponent {
  private dialog = inject(MatDialogRef<any>);

  public data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose() {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
  }

  closeDialog(): void {
    this.beforeClose();
    this.dialog.close();
  }

  handleResult(data) {
    this.dialog.close(data);
  }

}
